import { useState, useEffect } from 'react'
import { supabase } from '../lib/supabase'
import SessionReportView from './SessionReportView'
import SessionReportForm from './SessionReportForm'

export default function SessionReportList({ childId }) {
  const [reports, setReports] = useState([])
  const [loading, setLoading] = useState(true)
  const [selectedReport, setSelectedReport] = useState(null)
  const [editReport, setEditReport] = useState(null)

  useEffect(() => {
    fetchReports()
  }, [childId])

  const fetchReports = async () => {
    const { data, error } = await supabase
      .from('session_reports')
      .select('*, report_blocks(*)')
      .eq('child_id', childId)
      .order('created_at', { ascending: false })

    if (!error) setReports(data)
    setLoading(false)
  }

  const statusLabel = (status) => {
    if (status === 'draft') return { label: 'Brouillon', color: '#94a3b8' }
    if (status === 'pending_parent') return { label: 'En attente parent', color: '#f59e0b' }
    if (status === 'validated') return { label: 'Validé', color: '#10b981' }
  }

  if (loading) return <p style={{ color: '#94a3b8', fontSize: '14px' }}>Chargement...</p>

if (reports.length === 0) return null

if (selectedReport) return (
  <SessionReportView
    report={selectedReport}
    onClose={() => setSelectedReport(null)}
  />
)

if (editReport) return (
  <SessionReportForm
    childId={childId}
    existingReport={editReport}
    onClose={() => setEditReport(null)}
    onSaved={() => { setEditReport(null); fetchReports() }}
  />
)

  return (
    <div style={{ marginTop: '24px' }}>
      <h3 style={{ fontSize: '16px', fontWeight: '700', color: '#1e293b', marginBottom: '12px' }}>
        📋 Comptes rendus
      </h3>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
        {reports.map(report => {
          const s = statusLabel(report.status)
          return (
      <div key={report.id} onClick={() => {
         if (report.status === 'draft') setEditReport(report)
         else setSelectedReport(report)
      }} style={{
         border: '1px solid #e2e8f0', borderRadius: '12px', padding: '16px',
         backgroundColor: '#fff', cursor: 'pointer'
      }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div>
                  <p style={{ margin: 0, fontWeight: '600', color: '#1e293b', fontSize: '14px' }}>
                    {report.subject}
                  </p>
                  <p style={{ margin: '4px 0 0', fontSize: '12px', color: '#94a3b8' }}>
                    {new Date(report.created_at).toLocaleDateString('fr-FR', {
                      day: '2-digit', month: 'long', year: 'numeric'
                    })}
                    {report.report_blocks?.length > 0 && ` · ${report.report_blocks.length} élément(s)`}
                  </p>
                </div>
                <span style={{
                  padding: '4px 10px', borderRadius: '20px', fontSize: '12px',
                  fontWeight: '600', backgroundColor: s.color + '20', color: s.color
                }}>
                  {s.label}
                </span>
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}